const React = require('react');
const {
  account$,
} = require('../../../../../../emitters/account');
const AppIcon = require('../../../../../icons/Lunu');
const WrapperWithLoading = require('../../../../../dumb/WrapperWithLoading/B');


module.exports = (props) => {
  return (
    <div className="fixed s ovxH ovyA bgF ff$3 c0">
      <div className="hmin layoutRow fvaC fhaC pv50">
        <div>
          <div className="h80 layoutRow fhaC fvaE">
            <div>
              <a
                className="tdN olN dn o70:h"
                onClick={account$.signOut}
              >
                <div className="layoutRow fvaC fhaC">
                  <AppIcon className="w150 c0"/>
                </div>
                <div
                  className="fw3 f16 lh30 lts0em tc mt10"
                >Console</div>
              </a>
            </div>
          </div>
          <WrapperWithLoading
            loading={props.loading}
          >
            <div className="hmin100vh-260 hmin200@x-800 pv20 layoutRow fvaC fhaC">
              <div>
                <div
                  className="wmax mhA w300"
                >{props.children || null}</div>
                {props.subfooter || null}
              </div>
            </div>
          </WrapperWithLoading>
          <div className="h80 layoutRow fhaC fvaS">
            <div>{props.footer || null}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
